import { render, staticRenderFns } from "./AppRadioGroup.vue?vue&type=template&id=062aacf4&"
import script from "./AppRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./AppRadioGroup.vue?vue&type=script&lang=ts&"
import style0 from "./AppRadioGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadioGroup})
